import { useAssetBatchesRenderContext } from "../../contexts/AssetBatchesRenderContext";
import { MaskItemsControls, MaskItemsProps } from "./MaskItemsControls";

export const MaskItems = ({ step }: MaskItemsProps) => {
  const {
    isMediaMaskOn,
    isTextMaskOn,
    setIsMediaMaskOn,
    setIsTextMaskOn,
    setCurrentSwitchType,
  } = useAssetBatchesRenderContext();

  const onChangeMediaMask = (val: boolean) => {
    setIsMediaMaskOn(val);
    setCurrentSwitchType("media");
  };

  const onChangeTextMask = (val: boolean) => {
    setIsTextMaskOn(val);
    setCurrentSwitchType("text");
  };

  return (
    <MaskItemsControls
      key={"mask-items"}
      step={step}
      onChangeMediaMask={onChangeMediaMask}
      onChangeTextMask={onChangeTextMask}
      isMediaMaskOn={isMediaMaskOn}
      isTextMaskOn={isTextMaskOn}
    />
  );
};
